<template>
    <div class="cover-contianer" id="cover">
        <div class="image-contianer">
            <div class="coverSlider">
                <div v-for="img in slider" :key="img.id">
                    <img :src="img.img" alt="">
                </div>
            </div>
            <div class="cover-text">
                <h3 class="title">Modern and Conveniently-located </h3>
                <p>108Hill is just less than 10 minutes away from emerging business areas like Lao Security Exchange, ITECC mall, Vientiane Center, World Trade Center, international schools, embassies and government offices zone nearby Patuxay.</p>
            </div>
            <div class="icn-group">
                <div class="container">
                    <div class="columns">
                        <div class="column" v-for="icn in nearby" :key="icn.id">
                            <div class="icn"><p :class="icn.icn"></p></div>
                            <span class="label">{{icn.label}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data () {
            return{
                nearby:[
                    {icn:"icon-nearby-icon-04", label:"Fitness"},
                    {icn:"icon-nearby-icon-01", label:"Hospital"},
                    {icn:"icon-nearby-icon-08", label:"Mini-Mart"},
                    {icn:"icon-nearby-icon-07", label:"Cafe"},
                    {icn:"icon-nearby-icon-05", label:"Public Park"},
                    {icn:"icon-nearby-icon-02", label:"School"}
                ],
                slider:[
                    {img: '/image/cover.png'},
                    {img: '/image/cover1.jpg'},
                    {img: '/image/cover2.jpg'},
                    {img: '/image/cover3.jpg'}
                ]
            }
        },
        methods: {
            coverSlider(){
                $(".coverSlider").slick({
                    infinite: false,
                    arrow: false,
                    // nextArrow: $('.next'),
                    // prevArrow: $('.prev'),
                    // centerMode: true,
                })
            }
        },
        mounted(){
            this.coverSlider();
        }
    }
</script>

<style lang="scss" scoped>
$color-main: #2D1C1D;
.cover-text{
    position: absolute;
    top: 150px;
    left: 0;
    right: 0;
    width: 100%;
    color: #fff;
    p{
        max-width: 500px;
        padding: 0 100px;
        @media screen and (max-width: 690px){
            padding: 0 20px;
            font-size: 12px;
        }
    }
    h3{
        padding: 0 100px;
        color: #fff;
        @media screen and (max-width: 690px){
            padding: 0 20px;
            font-size: 20px;
        }
    }
}
.image-contianer{
    position: relative;
    height: 100vh;
    width: 100%;
    overflow: hidden;
    @include mobile{
        height: calc(100vh - 50px);
    }
    img{
        width: 100%;
        height: 100vh;
        -o-object-fit: cover;
        object-fit: cover;
        // position: absolute;
        // top: 0;
        // left: 0;
    }
    .icn-group{
        position: absolute;
        z-index: 1;
        bottom: 0;
        width: 100%;
        background-color: rgba($color: $color-main, $alpha: 0.6);
        padding: 10px 0;
        .columns{
            @include mobile{
                display: flex;
                overflow: scroll;
                -webkit-overflow-scrolling: touch;
            }
        }
        .title{
            font-size: 18px;
            color: #fff;
            margin-bottom: 10px;
        }
        .icn{
            font-size: 50px;
            font-family: 'icomoon';
        }
        .columns{
            .column{
                .icn{
                    text-align: center;
                    color: #fff;
                }
                .label{
                    white-space: pre;
                    font-size: 12px;
                    color: #fff;
                    font-weight: normal;
                    text-align: center;
                }
            }
        }
    }
}
</style>